import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  icon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  icon = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-teal-400 text-navy-900 hover:bg-teal-300 hover:shadow-[0_0_20px_rgba(0,212,170,0.3)]',
    secondary: 'bg-navy-700 text-white hover:bg-navy-600',
    outline: 'border border-teal-400/30 text-teal-400 hover:bg-teal-400/10'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-961">
      {children}
      {icon && <ArrowRight className="w-4 h-4" data-id="element-962" />}
    </motion.button>;
}